import { Talent } from '../../Classes'

const tier7 = [
  null,
  new Talent(
    'Elemental Mastery',
    'spell_nature_wispheal',
    ['When activated, this spell grants your next Fire, Frost or Nature damage spell a 100% critical strike chance and reduces the mana cost by 100%.'],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    'Instant',
    '3 min cooldown'
  ),
  null,
  null,
]

export default tier7
